module.exports = __webpack_public_path__ + "img/1.pexels-monstera-9429554.afdd311a.jpg";